import apiFetch from "./apiFetch";

const getCountries = () => apiFetch('/dictionary/countries');

export {
  getCountries,
};
